import DOMPurify from 'dompurify';
import decode from 'unescape';

const sanitizeHTML = (data, settings = {}) =>
  DOMPurify.sanitize(decode(data), {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['target'],
    ...settings
  });

export default sanitizeHTML;
